/* tslint:disable */
/* eslint-disable */
export enum InputDetailLevel {
    Drawing = 'Drawing',
    Volumetric = 'Volumetric',
    Detailed = 'Detailed',
    Textured = 'Textured'
}
